<template>
  <div>
    <b-tabs class="mb-3" content-class="d-none" id="stream-tab1">
      <b-tab
        :key="tag.id"
        v-for="tag in descriptionTagsTabs"
        no-body
        :disabled="load || (!hasCurrentStream && tag.tag === 'current_stream')"
        @click="descriptionTag = tag.tag"
        :active="descriptionTag === tag.tag"
        :id="tag.id"
        :title-link-class="{
          'language-selected__tab--active': descriptionTag === tag.tag,
          'text-dark': descriptionTag !== tag.tag,
        }"
        :title-item-class="{
          'language-selected__tab--load': load,
        }"
      >
        <template #title>
          <b-skeleton width="100%" v-if="load"></b-skeleton>
          <span
            v-else
            :style="{ opacity: !hasCurrentStream && tag.tag === 'current_stream' ? 0.7 : 1 }"
          >
            {{ tag.title }}
          </span>
        </template>
      </b-tab>
    </b-tabs>

    <div v-if="descriptionTag === 'current_stream'">
      <div class="campaign-edit-title">
        <h2 class="h2-like">{{ $t("edit_campaign.current_stream_title", "Current Stream") }}</h2>
      </div>
      <section class="matchers_page">
        <div class="row" v-if="streamsList.length > 0">
          <div
            class="col-12 col-lg-6"
            v-for="stream in streamsList.filter(
              (stream) => stream.attributes.meta.show_on_campaign_page
            )"
            :key="stream.id"
          >
            <stream-stats-plate
              :loading="load"
              :stream="stream"
              @edit-stream="editStream"
              @delete-stream="deleteStream"
            />
          </div>
          <div v-if="streamsList.length == 0" class="empty-result-message">
            {{ $t("edit_campaign.donation_stream_empty") }}
          </div>
        </div>
      </section>
    </div>

    <div v-else>
      <div class="campaign-edit-title">
        <h2 class="h2-like">{{ $t("edit_campaign.streams_title") }}</h2>
        <div class="btn-wrap">
          <stream-modal-form ref="modalStream"></stream-modal-form>
        </div>
      </div>

      <section class="matchers_page">
        <div class="row" v-if="streamsList.length > 0">
          <div class="col-12 col-lg-6" v-for="stream in streamsList" :key="stream.id">
            <stream-plate
              :loading="load"
              :stream="stream"
              @edit-stream="editStream"
              @delete-stream="deleteStream"
            />
          </div>
          <div v-if="streamsList.length == 0" class="empty-result-message">
            {{ $t("edit_campaign.donation_stream_empty") }}
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import axios from "axios";
import urls from "@/constants/urls.js";
import streamPlate from "./campaign-stream-plate.vue";
import streamStatsPlate from "./campaign-stream-stats-plate.vue";
import streamModalForm from "./stream-modal-form.vue";
import { notificationsMixin } from "@/mixins";

export default Vue.extend({
  components: {
    streamPlate,
    streamStatsPlate,
    streamModalForm,
  },
  mixins: [notificationsMixin],
  data() {
    return {
      descriptionTag: "current_stream",
      descriptionTagsTabs: [
        {
          tag: "current_stream",
          id: "tab-tooltip-target-current_stream",
          title: this.$t("edit_campaign.current_stream_tab_title", "Current Stream"),
        },
        {
          tag: "edit_stream",
          id: "tab-tooltip-target-edit_stream",
          title: this.$t("edit_campaign.edit_stream_tab_title", "Edit Stream"),
        },
      ],
      streamsList: [],
      load: false,
      errors: [],
      extend: `?${[
        "extend=campaign_stats",
        "extend=content",
        "extend=media",
        "extend=matchers",
        "extend=donation_levels",
        "extend=donation_streams",
      ].join("&")}`,
    };
  },

  computed: {
    ...mapState({
      streams: (state) => {
        let included = state.campaign.campaign.included;

        let relationships = state.campaign.campaign.data.relationships.donation_stream.data;

        let arrStreams = [];

        relationships.forEach((relationship) => {
          let stream = included.find(
            (el) => el.id == relationship.id && el.type == relationship.type
          );

          try {
            stream.attributes.meta = JSON.parse(stream.attributes.meta || "{}");
          } catch {
            stream.attributes.meta = {};
          }

          arrStreams.push(stream);
        });
        return arrStreams;
      },

      campaignId: (state) => state.campaign.campaign.data.id,
      orgId: () => localStorage.getItem("orgId"),
    }),

    hasCurrentStream() {
      return this.streamsList.some((stream) => stream.attributes?.meta?.show_on_campaign_page);
    },
  },

  methods: {
    editStream(stream) {
      this.$refs.modalStream.openModalEdit(stream);
    },

    deleteStream(stream) {
      this.errors = [];

      let message = this.$t("edit_campaign.confirm_delete_donation_stream");

      let options = {
        okText: this.$t("edit_campaign.confirm_delete"),
        cancelText: this.$t("edit_campaign.confirm_cancel"),
      };

      this.$dialog.confirm(message, options).then(() => {
        this.load = true;

        axios
          .delete(
            urls.apiPutDonationStream
              .replace(":orgId", this.orgId)
              .replace(":campaignId", this.campaignId)
              .replace(":donationstreamId", stream.id)
          )
          .then(() => {
            this.load = false;

            this.$store.dispatch("updateCampaign", this.extend);

            this.$_notificationsMixin_makeToast(
              "Success",
              this.$t("edit_campaign.success_delete_donation_streams")
            );
          })
          .catch((e) => {
            this.load = false;

            if (e.response.data) {
              if (e.response.data.error) {
                this.errors.push(e.response.data.error);
              } else {
                this.errors.push(this.$t("template.error_default"));
              }
            } else {
              this.errors.push(this.$t("template.error_default"));
            }
          });
      });
    },
  },

  watch: {
    streams() {
      this.streamsList = this.streams;
      if (!this.hasCurrentStream && this.descriptionTag === "current_stream") {
        this.descriptionTag = "edit_stream";
      }
    },
  },

  mounted() {
    this.$store.dispatch("updateCampaign", this.extend);
    this.streamsList = this.streams;
    this.descriptionTag = this.hasCurrentStream ? "current_stream" : "edit_stream";
  },
});
</script>

<style lang="scss" scoped>
.matchers_page {
  padding: 0px;
  &_search {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
    position: relative;
    > svg {
      fill: gray;
      position: absolute;
      left: 0;
      top: calc(50% - 12px);
    }
    > input {
      width: 100%;
      border-left: none;
      border-right: none;
      border-top: none;
      border-radius: 0;
      padding-left: 30px;
    }
  }
}
</style>
